// extracted by mini-css-extract-plugin
module.exports = {"detailsText":"DigitalReturnDetails_detailsText__RINrj","learnMoreLink":"DigitalReturnDetails_learnMoreLink__B8XkO"};